export const senderLists = (builder) => ({
    senderLists: builder.mutation({
      query: ({ page, limit, registered_by, category, country, search, status }) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: '/get_sender_ids_list',
          method: 'GET',
          params: { page, limit, registered_by, category, country, search, status },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  